import { render, staticRenderFns } from "./PageMaintenanceMode.vue?vue&type=template&id=067b451b"
import script from "./PageMaintenanceMode.vue?vue&type=script&lang=js"
export * from "./PageMaintenanceMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports